/**
 * Created by danielr on 2/27/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var ConnectorModel = require("manager-models/data-sources/conversation-sources/ConnectorModel");
    var RevisionedCollection = require("collections/RevisionedCollection");
    var ApiResources = require("assets/data/apiResources.json");

    var NAME = "ConnectorsCollection";

    var ConnectorsCollection = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        ConnectorsCollection = RevisionedCollection.extend({
            name: NAME,
            model: ConnectorModel,
            resource: ApiResources.AccountConfig.SourceConnectors,
            SOURCE_TYPES: ConnectorModel.SOURCE_TYPES,
            SOURCE_TYPE_CONFIGURATION: ConnectorModel.SOURCE_TYPE_CONFIGURATION,
            URL_PARAMETERS: ConnectorModel.URL_PARAMETERS,

            initialize: function (models, options) {
                options = options || {};
                this.urlParameters = options.urlParameters || ConnectorsCollection.URL_PARAMETERS.ACTIVATION;
                RevisionedCollection.prototype.initialize.call(this, models, options);
            },

            fetch: function(options) {
                options = options || {};
                options.reset = true;
                if (options.fetchOptions.urlParameters) {
                    this.urlParameters = options.fetchOptions.urlParameters;
                }

                return RevisionedCollection.prototype.fetch.call(this, options);
            },

            url: function(){
                var url = RevisionedCollection.prototype.url.apply(this, arguments);
                url = url + this.urlParameters;
                return url;
            },

            getConnectorConfigurationByType: function(type) {
                return ConnectorModel.SOURCE_TYPE_CONFIGURATION[type];
            },

            getConnectorsByType: function(type) {
                var filter = {};
                filter[ConnectorModel.KEYS.TYPE] = type;
                return this.where(filter);
            },

            getRevision: function() {
                // Because the url parameters are different between each fetch we are doing, we cannot use revision and 304 implementation.
                // We always need to get the data from the server.
                return -1;
            }
        });

    }

    LE.module("LEManager", moduleDefinition);

    ConnectorsCollection.NAME = NAME;
    ConnectorsCollection.URL_PARAMETERS = ConnectorModel.URL_PARAMETERS;
    ConnectorsCollection.SOURCE_TYPES = ConnectorModel.SOURCE_TYPES;
    ConnectorsCollection.SOURCE_TYPE_CONFIGURATION = ConnectorModel.SOURCE_TYPE_CONFIGURATION;

    return ConnectorsCollection;
});
